export const Splits = Object.freeze({
    BattingLeague: 594,
    BattingTeam: 597,
    DaysOfRest: 601,
    TimesThruOrder: 616,
    PitcherHanded: 609,
    PitchingLeague: 608,
    PitchingTeam: 610
})
